import { api } from "../intreceptor/apiInterceptor";

export interface CreateGeneralContractorRequest {
  name: string;
  address?: {
    address?: string | null;
    city?: string | null;
    province?: string | null;
    postalCode?: string | null;
    coordinates?: number[] | null;
  } | null;
  active?: boolean | null;
  userId?: string | null;
  ignoreSimilarNameWarning?: boolean;
}

export interface GeneralContractor {
  id: string;
  name: string;
  active: boolean;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
  address?: {
    id: string;
    address: string;
    city: string;
    postalCode: string;
    coordinates: {
      type: string;
      coordinates: number[];
    };
    province: {
      id: string;
      name: string;
    };
  } | null;
}

export interface GetGeneralContractorsParams {
  status?: string[];
  generalContractor?: string[];
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  limit?: number;
  page?: number;
}

export interface PaginatedGeneralContractorResponse {
  data: GeneralContractor[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

export const GeneralContractorService = {
  createGeneralContractor: async (data: CreateGeneralContractorRequest) => {
    return api.fetch('/general-contractor/createGeneralContractor', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  updateGeneralContractor: async (id: string, data: CreateGeneralContractorRequest) => {
    return api.fetch(`/general-contractor/updateGeneralContractor/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },

  getGeneralContractors: async (): Promise<GeneralContractor[]> => {
    return api.fetch('/general-contractor/getGeneralContractors');
  },

  getGeneralContractorById: async (id: string): Promise<GeneralContractor> => {
    return api.fetch(`/general-contractor/get-general-contractor/${id}`, {
      method: 'GET'
    });
  },

  getGeneralContractorsWithFilters: async (params: GetGeneralContractorsParams): Promise<PaginatedGeneralContractorResponse> => {
    const queryParams = new URLSearchParams();
    if (params.status) {
      queryParams.append('status', JSON.stringify(params.status));
    }
    if (params.generalContractor) {
      queryParams.append('generalContractor', JSON.stringify(params.generalContractor));
    }
    if (params.search) {
      queryParams.append('search', params.search);
    }
    if (params.sortBy) {
      queryParams.append('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
      queryParams.append('sortOrder', params.sortOrder);
    }
    if (params.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    if (params.page) {
      queryParams.append('page', params.page.toString());
    }
    return api.fetch(`/general-contractor/get-general-contractors?${queryParams.toString()}`);
  },

  deleteGeneralContractor: async (id: string) => {
    return api.fetch(`/general-contractor/delete-general-contractor/${id}`, {
      method: 'DELETE',
      body: JSON.stringify({ userId: 'current-user' }) // This will be updated when we integrate with auth
    });
  },

  getGeneralContractorsFromJobsites: async (): Promise<GeneralContractor[]> => {
    return api.fetch('/general-contractor/get-general-contractors-from-jobsites');
  },

  checkDeactivationEligibility: async (id: string): Promise<{ canDeactivate: boolean; reason?: string }> => {
    return api.fetch(`/general-contractor/canDeactivate/${id}`, {
      method: 'GET'
    });
  }
}